import React from "react";
// ##
import SettingTable from "../../modules/Setting/components/SettingsTable";

export default function SettingsPage() {
  return <SettingTable />;
}
